import { render, staticRenderFns } from "./ProviderDetail.vue?vue&type=template&id=98cdd650&scoped=true&"
import script from "./ProviderDetail.vue?vue&type=script&lang=js&"
export * from "./ProviderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProviderDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProviderDetail.vue?vue&type=style&index=1&id=98cdd650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cdd650",
  null
  
)

export default component.exports